import { render, staticRenderFns } from "./PendingRequestsOverview.vue?vue&type=template&id=1b7e2ce6&scoped=true&"
import script from "./PendingRequestsOverview.vue?vue&type=script&lang=js&"
export * from "./PendingRequestsOverview.vue?vue&type=script&lang=js&"
import style0 from "./PendingRequestsOverview.vue?vue&type=style&index=0&id=1b7e2ce6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7e2ce6",
  null
  
)

export default component.exports